import React, { useState } from 'react'
import PropTypes from 'prop-types'
import InfoBox from '../Shared/InfoBox'
import { useTranslation } from 'react-i18next'
import useCustomTranslation from 'hooks/useCustomTranslation'

import SelectItem from '../Shared/SelectItem'
import { DEFAULT_CAMPAIGN_GOAL, CampaignGoal, enumValues } from '../../api/models'

/**
 * Campaign goals input.
 * @Tags( recommendations, campaigns )
 */
export default function CampaignGoals({
  event,
  selectedGoal = DEFAULT_CAMPAIGN_GOAL,
  onGoalSelected,
  disabled,
}) {
  const { t } = useTranslation()
  const [displayDisabledOverlay, setDisplayDisabledOverlay] = useState(false)
  const { getTranslation } = useCustomTranslation(event)
  return (
    <div
      onMouseEnter={() => setDisplayDisabledOverlay(disabled && true)}
      onMouseLeave={() => setDisplayDisabledOverlay(false)}
      className="d-flex flex-column justify-content-between h-100"
    >
      <InfoBox
        title={t('Tips.Recommendations.CampaignGoal.title')}
        body={
          <div className="d-flex flex-column gap-2">
            <span>{t('Tips.Recommendations.CampaignGoal.body1')}</span>
            <span>{t('Tips.Recommendations.CampaignGoal.body2')}</span>
            <span>{t('Tips.Recommendations.CampaignGoal.body3')}</span>
          </div>
        }
        placement="bottom"
      >
        <h2 className="d-inline-block section-title">
          {t('Recommendations.campaignGoal.selectLabel')}
        </h2>
      </InfoBox>
      <div style={{ position: 'relative', height: '100%' }}>
        <div
          className="rounded d-flex flex-column gap-3 event-header-card h-100"
        >
          {enumValues(CampaignGoal).map((goal) => {
            return (
              <SelectItem
                key={goal}
                checked={goal === selectedGoal}
                onChange={() => onGoalSelected(goal)}
                disabled={disabled}
                title={getTranslation(`Recommendations.campaignGoal.goals.${goal}`)}
              />
            )
          })}
        </div>
        {displayDisabledOverlay && (
          <div className="disabled-overlay">{t('Recommendations.campaignGoal.notEditable')}</div>
        )}
      </div>
    </div>
  )
}

CampaignGoals.propTypes = {
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  budget: PropTypes.number,
  selectedGoal: PropTypes.string,
  onGoalSelected: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  event: PropTypes.object,
}
